import { render, staticRenderFns } from "./InlineSelect.vue?vue&type=template&id=b457a872&scoped=true&"
import script from "./InlineSelect.vue?vue&type=script&lang=js&"
export * from "./InlineSelect.vue?vue&type=script&lang=js&"
import style0 from "./InlineSelect.vue?vue&type=style&index=0&id=b457a872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b457a872",
  null
  
)

export default component.exports